import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth-service/auth.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-entreppayment',
  templateUrl: './entreppayment.component.html',
  styleUrls: ['./entreppayment.component.scss']
})
export class EntreppaymentComponent implements OnInit {

  currentUser = null;
  paymentsLists: Array<any> = [];
  compId = null;
  hideNav = Number(localStorage.getItem('hideNav'));
  displayedColumns: string[] = [
    'paymentDate',
    'amount',
    'status',
    'userCount',
    'paymentMethod',
    'stripePaymentId'
  ];

  constructor(private location: Location, private authService: AuthService) { }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser.compId) {
      this.compId = this.currentUser.compId;
		  this.loadPayments();
    }
  }

  copyToClipboard(stripePaymentId: string) {
    const el = document.createElement('textarea');
    el.value = stripePaymentId;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  
    // Ajouter un message 'ID copied' pour une courte durée
    const element = this.paymentsLists.find(item => item.stripePaymentId === stripePaymentId);
    if (element) {
      element.idCopied = true;
  
      // Masquer le message après 2 secondes
      setTimeout(() => {
        element.idCopied = false;
      }, 1000);
    }
  }
  
  

  loadPayments(){
    this.authService.getCompanyPayments(this.compId).subscribe(res => {
      this.paymentsLists = res['hydra:member'];
    })
  }

  goBack(){
    this.location.back();
    //this.router.navigate(['/project/'+this.recentProject]);
    //window.history.back();
  }

}
